const { GET_MANAGE_USERS } = require("src/actions/types");

const initialState = { UsersList: [] };

const ManageUsersReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_MANAGE_USERS:
      return {
        ...state,
        UsersList: payload,
      };
    default:
      return state;
  }
};

export { ManageUsersReducer };
